import styled from 'styled-components';
import { H3, Small, Body } from 'components/Typography';
import DefaultAvatar from 'components/Avatar';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2rem;
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(H3)`
  margin-bottom: 0.5rem;
`;

// TODO: TFR-44 move to typography group
export const Subtitle = styled(Small)`
  margin-bottom: 1rem;
  opacity: 60%;
`;

// TODO: TFR-44 move to container group

export const List = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 2rem 2.5rem;
  border-radius: 1.5rem;
  height: max-content;
`;

// TODO: TFR-49 split components into two or more different logical components
export const ListItem = styled.div`
  display: grid;
  grid-template-columns: auto 1fr 1fr;
  align-items: center;

  :not(:last-child) {
    margin-bottom: 1.75rem;
  }
`;

// TODO: TFR-45:Avatar make unique name or do not export
export const Avatar = styled(DefaultAvatar)`
  margin-right: 1rem;
`;

// TODO: TFR-45:Name make unique name or do not export
export const Name = styled(Body)`
  font-weight: 600;
`;

// TODO: TFR-44 move to typography group
export const PhoneNumber = styled(Body)`
  opacity: 80%;
  font-variant-numeric: tabular-nums;
`;
